import React, {useState} from 'react';
import { useTranslation } from 'react-i18next';
import styles from './companies-card.module.scss'
import chevron from '../../../../images/chevron.svg';
import suitcase from '../../../../images/tenant/suitcase.svg';
import building from '../../../../images/tenant/building.svg';
import mobile from '../../../../images/tenant/mobile.svg';
import phone from '../../../../images/tenant/phone.svg';
import mail from '../../../../images/tenant/mail.svg';
import browse from '../../../../images/tenant/browse.svg';
import link from '../../../../images/tenant/link.svg';
import x from '../../../../images/x.svg';
import facebook from '../../../../images/facebook.svg';
import linkedin from '../../../../images/linkedin.svg';
import instagram from '../../../../images/instagram.svg';
import qrCode from '../../../../images/qr-code.svg';
import Modal from "../../../../shared/modal/modal";
import QrCode from "../../../../shared/qr-code/qr-code";
import {Company} from "../../../../services/reducers/companies";
import {useSearchParams} from "react-router-dom";
import { EMS_BASE_URL } from "../../../../utils/ems";

interface CompanyCardProps {
    tenant: Company;
    className?: string;
    qrHref?: string
}

const CompanyCard: React.FC<CompanyCardProps> = ({ tenant, className, qrHref = window.location.href}) => {
    const { t, i18n } = useTranslation();
    const [qrCodeVisible, setQrCodeVisible] = useState<boolean>(false);
    const [branchesOpen, setBranchesOpen] = useState<boolean>(false);
    const [searchParams, setSearchParams] = useSearchParams();

    const isOpen = searchParams.get("tid")?.split(",").includes(String(tenant.tenant_id)) || false;

    const toggleCard = () => {
        const currentParams = new URLSearchParams(searchParams);
        const currentTid = currentParams.get("tid")?.split(",") || [];
        const tenantId = String(tenant.tenant_id);

        let updatedParams;
        if (isOpen) {
            updatedParams = currentTid.filter((id) => id !== tenantId);
        } else {
            updatedParams = [...new Set([...currentTid, tenantId])];
        }

        if (updatedParams.length > 0) {
            currentParams.set("tid", updatedParams.join(","));
        } else {
            currentParams.delete("tid");
        }

        setSearchParams(currentParams);
    };

    const toggleBranches = () => {
        setBranchesOpen(prev => !prev);
    };

    return (
        <>
            <div id={`company-closed-card-${tenant.tenant_id}`} className={`${styles.card} ${className && className}`}>
                <div className={styles.header}>
                    <div className={styles.title}>{tenant.name_en}</div>
                    <button
                        onClick={toggleCard}
                        className={isOpen ? styles.open : ''}
                    >
                    </button>
                </div>
                <div className={styles.date}>{t('companies-card.established')} {tenant.date_of_establish}</div>
                {!isOpen && <div className={styles.city}>{i18n.language === "ar" ? tenant.estateAr : tenant.estateEn}</div>}
                {isOpen && (
                    <div className={styles.information}>
                            {/* <button className={styles.navigateBtn}>
                                <img src={navigate} alt="navigate"/> {t('companies-card.displayInGoogleMaps')}
                            </button> */}
                        <ul className={styles.companyDetails}>
                            <li>
                                <img src={suitcase} alt="suitcase" /> {t('companies-card.branches')} {tenant.branches.length}
                                <button
                                    onClick={toggleBranches}
                                    className={`${styles.chevronButton} ${branchesOpen ? styles.open : ''}`}
                                >
                                    <img src={chevron} alt="chevron" />
                                </button>
                            </li>
                            {branchesOpen && (
                                <ul className={styles.branchList}>
                                    {tenant.branches.map((branch, index) => (
                                        <li key={index}>
                                            {branch}
                                        </li>
                                    ))}
                                </ul>
                            )}
                            <li>
                                <img src={building} alt="building"/> {i18n.language === "ar" ? tenant.estateAr : tenant.estateEn}
                            </li>
                            <li>
                                <img src={mobile} alt="mobile"/> {tenant.mobile}
                            </li>
                            <li>
                                <img src={phone} alt="phone" />
                                {tenant.phone}
                                {tenant.other_phones && `, ${tenant.other_phones}`}
                            </li>
                            <li>
                                <img src={mail} alt="mail"/>  {tenant.email}
                            </li>
                            <li>
                                <img src={browse} alt="browse"/> {tenant.website}
                            </li>
                            <li>
                                <img src={link} alt="link"/>
                                <a
                                    className={styles.link}
                                    href={`${EMS_BASE_URL}/newDir/TenantDetails.aspx?tid=${tenant.tenant_id}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    {t('companies-card.companyProfile')}
                                </a>
                            </li>
                        </ul>
                        <div className={styles.social}>
                            <p>{t('companies-card.share')}</p>
                            <div className={styles.links}>
                            {/*<span>*/}
                            {/*    <img className={styles.imgLink} src={x} alt='x'/>*/}
                            {/*</span>*/}
                            {/*    <span>*/}
                            {/*    <img className={styles.imgLink} src={facebook} alt='facebook'/>*/}
                            {/*</span>*/}
                            {/*    <span>*/}
                            {/*    <img className={styles.imgLink} src={linkedin} alt='linkedin'/>*/}
                            {/*</span>*/}
                            {/*    <span>*/}
                            {/*    <img className={styles.imgLink} src={instagram} alt='instagram'/>*/}
                            {/*</span>*/}
                                <button onClick={() => setQrCodeVisible(true)} className={styles.qrCode}>
                                    <img className={styles.imgLink} src={qrCode} alt='qrCode'/>
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
            {qrCodeVisible && (
                <Modal onClose={() => setQrCodeVisible(false)}>
                    <QrCode title={`QR Code ${tenant.name_en}`} href={qrHref} from="companies"/>
                </Modal>
            )}
        </>
    );
};

export default CompanyCard;
